import { makeStyles, tokens } from "@fluentui/react-components";

export const useMessageListStyles = makeStyles({
  assistantMessage: {
    "& p": {
      paddingTop: "8px",
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    marginBottom: "16px",
    marginLeft: "8px",
	marginRight: "8px",
	marginTop: "16px",
  },
  assistantMessageBubble: {
    "& li": {
      marginBottom: "4px",
      paddingLeft: "4px",
    },
    "& ol": {
      listStyleType: "decimal",
      marginBottom: "8px",
      marginTop: "8px",
      paddingLeft: "24px",
    },
    "& table": {
      borderCollapse: "collapse",
      display: "block",
      marginBottom: "16px",
      marginTop: "16px",
      maxWidth: "100%",
      overflowX: "auto",
      width: "auto",
    },
    "& td": {
      border: "1px solid #D1D5DB",
      minWidth: "80px",
      padding: "6px 8px",
      textAlign: "left",
      whiteSpace: "normal",
      wordBreak: "break-word",
    },
    "& th": {
      backgroundColor: "#E5E7EB",
      border: "1px solid #D1D5DB",
      fontWeight: "600",
      minWidth: "80px",
      padding: "6px 8px",
      textAlign: "left",
      whiteSpace: "nowrap",
    },
    "& tr:nth-of-type(even)": {
      backgroundColor: "#F9FAFB",
    },
    "& ul": {
      listStyleType: "disc",
      marginBottom: "8px",
      marginTop: "8px",
      paddingLeft: "24px",
    },
    backgroundColor: "#F3F4F6",
    color: "#1F2937",
    marginTop: "4px",
    overflowX: "auto",
    padding: "12px 16px",
    wordBreak: "break-word",
  },
  avatar: {
    alignItems: "center",
    display: "flex",
    gap: "8px",
    marginBottom: "4px",
  },
  avatarText: {
    color: "#374151",
    fontSize: "14px",
    fontWeight: "700",
	paddingTop: "0px",
  },
  dismissButton: {
    backgroundColor: "#6B7280",
    color: "white",
  },
  errorActions: {
    display: "flex",
    gap: "8px",
    marginTop: "8px",
  },
  errorBubble: {
    backgroundColor: "#FEE2E2",
    border: "1px solid #FECACA",
    borderRadius: "12px",
    color: "#DC2626",
    maxWidth: "70%",
    padding: "12px 16px",
  },
  errorButton: {
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "12px",
    padding: "4px 8px",
  },
  errorMessage: {
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: "16px",
  },
  errorText: {
    fontSize: "12px",
    marginTop: "4px",
  },
  fadeIn: {
    opacity: 1,
    transform: "translateY(0)",
    transition: "all 0.2s ease-out",
  },
  fadeOut: {
    opacity: 0,
    transform: "translateY(8px)",
  },
  loadingBubble: {
    backgroundColor: "#F3F4F6",
    borderRadius: "12px",
    padding: "12px 16px",
  },
  loadingDot: {
    animation: "bounce 1.4s ease-in-out infinite both",
    backgroundColor: "#9CA3AF",
    borderRadius: "50%",
    height: "8px",
    width: "8px",
  },
  loadingDots: {
    display: "flex",
    gap: "4px",
  },
  loadingMessage: {
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: "16px",
  },
  messageContainer: {
    "& p": {
      paddingTop: "8px",
    },
    display: "flex",
    flex: "1",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
    position: "relative",
    width: "100%",
  },
  messagesWrapper: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflowY: "auto",
    width: "100%",
  },
  retryButton: {
    backgroundColor: "#DC2626",
    color: "white",
  },
  scrollButton: {
    "&:hover": {
      backgroundColor: "#F9FAFB",
    },
    alignItems: "center",
    backgroundColor: "white",
    border: "1px solid #D1D5DB",
    borderRadius: "50%",
    bottom: "12px",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
    cursor: "pointer",
    display: "flex",
    height: "40px",
    justifyContent: "center",
    position: "absolute",
    right: "50%",
    transform: "translateX(50%)",
    transition: "all 0.2s",
    width: "40px",
    zIndex: 10,
  },
  typingIndicator: {
	animation: "pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite",
    color: "#6B7280",
	fontWeight: tokens.fontWeightRegular,
  },
  userMessage: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "8px",
  },
  userMessageBubble: {
    "& p": {
      paddingTop: "8px",
    },
    backgroundColor: "white",
    borderRadius: "4px",
    color: "black",
    padding: "12px 16px",
    wordBreak: "break-word",
  },
});
